import { useQuiz } from '@/api/course-builder';
import { FormShell } from '@/components/shared/form-shell';
import { CreateQuizForm } from './create-quiz-form';
import { ManageQuiz } from './manage-quiz';

type Props = { lessonId: number; quizId: number | null; courseId: number; onClose: () => void };

export function QuizBuilderDialog({ lessonId, quizId, courseId, onClose }: Props) {
  const { data: quiz, isLoading } = useQuiz(quizId ?? 0);
  const hasQuiz = !!quizId && !!quiz;

  if (isLoading && quizId) {
    return (
      <FormShell title="Evaluación" onClose={onClose}>
        <p className="py-8 text-center text-sm text-muted-foreground">Cargando...</p>
      </FormShell>
    );
  }

  return hasQuiz ? (
    <ManageQuiz quiz={quiz} courseId={courseId} onClose={onClose} />
  ) : (
    <CreateQuizForm lessonId={lessonId} courseId={courseId} onClose={onClose} />
  );
}
